import { GetServerSideProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { HomeownersProps, HomeownersTemplate } from "@templates/homeowners";
import { getDirectusInstance } from "@fhlib/directus";
import { getParsedHomeownersData } from "server/homeowners/getParsedHomeownersData";

const Homeowners: NextPage<HomeownersProps> = ({ homeOwnersData }) => {
  const { t } = useTranslation("homeowners");
  return (
    <>
      <Head>
        <title>{t("title")} - FeelingHome</title>
      </Head>
      <HomeownersTemplate homeOwnersData={homeOwnersData} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ defaultLocale, locale }) => {
  const directus = await getDirectusInstance();
  const homeownersService = directus.items("homeowners");
  const homeownersServiceResponse = await homeownersService.readByQuery({
    limit: -1,
    fields: HOMEOWNERS_FIELDS,
  });
  const parsedData = getParsedHomeownersData(homeownersServiceResponse?.data?.[0], locale, defaultLocale);

  return {
    props: {
      ...(await serverSideTranslations(locale ?? "en", ["common", "homeowners"])),
      homeOwnersData: parsedData,
    },
  };
};

const HOMEOWNERS_FIELDS = [
  "id",
  // top section
  "cover_image",
  "first_section_fields.*",
  "first_section_image",
  // review cards section(s)
  "review_cards.id",
  "first_review_cards_title.*",
  "review_cards.card_image",
  "review_cards.property_slug",
  "review_cards.review_card_data.*",
  "second_review_cards_title.*",
  // reasons to trust section
  "trust_reasons_title.*",
  "trust_reasons.id",
  "trust_reasons.image",
  "trust_reasons.trust_reasons_data.*",
];

export default Homeowners;
